import React, { Fragment } from 'react';

import withAuthServerSideProps from '@/libs/auth';
import { PageLayout } from '@/layouts/shared';
import { GetServerSidePropsContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import MetaTag from '@/components/ui/MetaTag';

const CheckoutPolicyPage = () => {
  const companyName = process.env.COMPANY_NAME;
  return (
    <Fragment>
      <MetaTag title="CHÍNH SÁCH KIỂM HÀNG" description="CHÍNH SÁCH KIỂM HÀNG" />
      <div className="container tw-mx-auto md:tw-border-t tw-border-primary-main tw-pt-8 tw-pb-10">
        <div className="tw-flex tw-gap-y-1 tw-flex-col tw-leading-7">
          <h1 className="tw-text-center tw-font-bold tw-text-lg lg:tw-text-2xl tw-mb-5 tw-uppercase">
            Chính sách kiểm hàng
          </h1>
          <div className="tw-leading-7 tw-flex tw-flex-col tw-gap-y-2">
            <h3 className="tw-font-semibold tw-text-primary-main ">1. Định nghĩa:</h3>
            <p>
              Kiểm hàng là thực hiện các công việc kiểm tra và so sánh các sản phẩm/hàng hóa nhận được trong kiện hàng
              nhận từ <b>{companyName}</b> với các sản phẩm hiển thị ở từng link sản phẩm trong đơn hàng (Khách đã đặt)
              trên <b>{companyName}</b>. Số lượng, màu sắc, kích cỡ, thông số kỹ thuật...
            </p>
            <h3 className="tw-font-semibold tw-text-primary-main ">2. Quy định:</h3>
            <p className="tw-font-semibold">* Thời gian kiểm hàng:</p>
            <p>Ngay khi sản phẩm được giao tới khách hàng.</p>
            <p className="tw-font-semibold">* Phạm vi kiểm tra hàng hóa:</p>
            <p>
              - <b>{companyName}</b> thực hiện việc kiểm đếm số lượng sản phẩm được đặt hàng trên <b>{companyName}</b>{' '}
              (theo các lần phát hàng), đối chiếu, so sánh các sản phẩm sẽ giao với sản phẩm đã đặt trên đơn theo các
              tiêu chí:
            </p>
            <ul className="tw-ps-2">
              <li>
                + Theo các thuộc tính cơ bản phân loại hàng hóa mà Khách hàng đã thao tác click chọn nhập hàng khi đưa
                vào giỏ hàng.
              </li>
              <li>+ Theo mẫu mã được hiển thị bởi ảnh đại diện của sản phẩm được lưu khi đặt hàng.</li>
              <li>
                + <b>{companyName}</b> kiểm tra các lỗi phát hiện nhanh bằng mắt thường như rách/thủng/gãy các mảng lớn,
                nhưng không cam kết phát hiện các lỗi kỹ thuật.
              </li>
            </ul>
            <p>
              - Để kiểm tra hàng hóa, chúng tôi phải mở sản phẩm trước sự chứng kiến của quý khách hàng. Nếu có nhu cầu
              giữ nguyên hộp/tem/seal…của hàng hóa, Quý khách vui lòng ghi chú trên đơn để nhân viên kiểm hàng nắm thông
              tin. Khi đó, Chúng tôi sẽ chỉ hỗ trợ khiếu nại nếu hàng hóa bên trong có sự sai khác. Các bước kiểm hàng
            </p>
            <p>
              - Khi Quý khách nhận hàng, vui lòng làm theo các bước dưới đây để được hỗ trợ tốt nhất trong trường hợp
              đơn hàng phát sinh một trong các lỗi sau: Không đúng chủng loại, sai số lượng, kích thước, màu sắc,…{' '}
            </p>
            <p>
              <b>Bước 01:</b> Quý khách quay video quá trình mở hàng, kiểm tra hàng hóa nhằm mục đích kiểm tra số lượng,
              kiểm tra phân loại sản phẩm trùng khớp với trên hóa đơn. Quá trình quay video ghi lại thông tin gồm: Mã
              đơn hàng, người gửi, người nhận,…của đơn hàng.
            </p>
            <p>
              <b>Bước 02:</b> Quý khách vui lòng liên hệ trực tiếp số điện thoại Hotline: 03.3333.6789 thông báo lỗi
              phát sinh xảy ra với đơn hàng của Quý khách. Việc giải quyết yêu cầu khiếu nại của Quý khách sẽ được bộ
              phận xử lí khiếu nại của <b>{companyName}</b> xử lí. Các yêu cầu khiếu nại sẽ được chúng tôi phân loại và
              xử lí theo từng trường hợp cụ thể, nhằm mục đích hỗ trợ Quý khách được nhanh nhất
            </p>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export const getServerSideProps = withAuthServerSideProps(
  async ({ locale }: GetServerSidePropsContext) => {
    return {
      props: {
        layout: PageLayout.New,
        ...(await serverSideTranslations(locale as string, ['layout'])),
      },
    };
  },
  { isAntiAuth: false, isPublic: true }
);

export default CheckoutPolicyPage;
